// Bundled fallback content. The live site normally renders whatever the admin
// has published (GET /api/site-content); this is what shows if the API is
// unreachable, and it is also the shape the admin edits.
const BASE = 'https://www.imperialagrooverseas.com';
const img = (p) => `${BASE}/${p}`;
const codes = (prefix, nums) => nums.map((n) => `${prefix}-${n}`);

const DEFAULTS = {
  company: {
    name: 'Imperial Agro Overseas',
    logo: img('assets/images/logo.png'),
    tagline:
      '🌾 Premium Quality Basmati Rice | ✨ Rich Aroma & Exceptional Taste | 🇮🇳 Trusted Choice For Every Indian Home | 🍚 Swaad Aur Sehat Ka Raaz Golden Taj & Sunehra Taj Rice',
    about:
      'Imperial Agro Overseas is a trusted exporter and supplier of premium quality Basmati Rice. Through our brands Golden Taj and Sunehra Taj, we deliver exceptional taste, aroma and quality to customers worldwide.',
    phones: ['7248175000', '7248275000'],
    whatsapp: '917248175000',
    whatsappText: 'Hello I am interested in your rice products',
    email: 'support@imperialagrooverseas.com',
    address: 'Taraori, Karnal, Haryana, India',
    brochure: img('assets/brochure/Imperial-Agro-Overseas-Brochure.pdf'),
    sites: ['www.goldentaj.in', 'www.sunehrataj.com', 'www.goldentajrice.com', 'www.shahipakwan.com', 'www.imperialagrooverseas.com'],
    offices: [
      { label: 'Head Office', value: 'Taraori, Karnal, Haryana' },
      { label: 'Branch Office', value: 'Rudrapur, Uttarakhand' },
    ],
    social: { facebook: '', instagram: '', linkedin: '', youtube: '' },
  },

  heroSlides: [1, 2, 3, 4].map((n) => img(`assets/images/banner/hero${n}.jpg`)),

  popup: { enabled: true, image: img('assets/images/offer-popup.jpg'), link: '' },

  productImageBase: `${BASE}/assets/images/products`,

  brands: [
    {
      slug: 'golden-taj',
      name: 'Golden Taj',
      image: img('assets/images/brands/golden-taj-mhfil.png'),
      heroTitle: 'Golden Taj Rice - Premium Quality Basmati Rice Collection',
      dir: 'golden-taj',
      products: {
        basmati: codes('GT', [36, 50, 66, 72, 74, 80, 86, 88, 90, 99]),
        biryani: codes('GT', [18, 45, 65, 75, 82, 91, 95]),
        rozana: codes('GT', [15, 22, 33, 35, 55, 63, 83]),
      },
    },
    {
      slug: 'sunehra-taj',
      name: 'Sunehra Taj',
      image: img('assets/images/brands/sunehra-taj.png'),
      heroTitle: 'Sunehra Taj Rice - Premium Quality Basmati Rice Collection',
      dir: 'sunehra-taj',
      products: {
        basmati: codes('GT', [36, 50, 66, 72, 74, 80, 86, 88, 90, 99]),
        biryani: codes('GT', [18, 45, 65, 75, 82, 91, 95]),
        rozana: codes('GT', [15, 22, 33, 35, 55, 63, 83]),
      },
    },
    {
      slug: 'shahi-pakwan',
      name: 'Shahi Pakwan',
      image: img('assets/images/brands/sp.jpg'),
      heroTitle: 'Shahi Pakwan Rice - Premium Quality Basmati Rice Collection',
      dir: 'sp',
      products: {
        basmati: codes('SP', [11, 22, 33, 44, 55, 66, 77, 88, 99]),
        biryani: codes('SP', [15, 25, 35, 45, 65]),
        rozana: codes('SP', [41, 71, 81, 91]),
      },
    },
  ],

  certification: {
    title: 'Our Certifications',
    text: 'Imperial Agro Overseas follows high quality standards to deliver premium rice products with complete customer satisfaction.',
    image: img('assets/images/iso.jpg'),
  },

  aboutHome: {
    image: img('assets/images/company/about.jpg'),
    title: 'Bringing Purity, Aroma & Taste To Every Home',
    text: 'Imperial Agro Overseas is committed to delivering world-class Basmati Rice through its premium brands Golden Taj and Sunehra Taj. We combine traditional farming expertise with advanced processing technology.',
  },

  festivals: [
    { title: 'Diwali Celebrations', image: img('assets/images/festivals/diwali.jpg'), text: 'Celebrate the Festival of Lights with aromatic Basmati Rice. Perfect for festive feasts, family dinners and delicious traditional recipes.' },
    { title: 'Eid Specials', image: img('assets/images/festivals/eid.jpg'), text: 'Prepare delicious biryani and festive meals with Golden Taj Rice and make every Eid celebration more memorable.' },
    { title: 'Wedding Celebrations', image: img('assets/images/festivals/wedding.jpg'), text: 'Serve premium quality rice at weddings and grand celebrations with rich aroma, long grains and authentic taste.' },
    { title: 'Family Gatherings', image: img('assets/images/festivals/family-dinner.jpg'), text: 'Bring families together with delicious homemade meals prepared using premium Golden Taj Basmati Rice.' },
  ],

  features: [
    { title: 'Why Choose Us', text: 'Discover why Golden Taj stands apart with its naturally aromatic, extra-long grains and consistent cooking performance.', image: img('assets/images/whychooseus.jpg') },
    { title: 'Strict Quality Assurance', text: 'Every single batch undergoes rigorous purity, moisture, and cooking tests to guarantee unmatched kitchen consistency.', image: img('assets/images/qualityassurance.jpg') },
    { title: 'Safety You Trust', text: 'Following international food safety norms with state-of-the-art hygienic processing, safe packaging, and controlled storage.', image: img('assets/images/saftyyoucantrust.jpg') },
    { title: 'Precision Processing Facility', text: 'Precision in every step ensures unmatched purity through state-of-the-art milling, grading, color sorting, and packaging.', image: img('assets/images/precision.jpg') },
    { title: 'Growing Responsibly', text: 'Deeply committed to eco-friendly farming and sustainable practices that preserve nature and protect future generations.', image: img('assets/images/grow.jpg') },
    { title: 'Built On Trust', text: 'Putting our customers first with reliable, on-time supply, service excellence, and long-term global partnerships.', image: img('assets/images/relationship.jpg') },
    { title: 'Serving Global Markets', text: 'Supplying authentic Indian Basmati rice to retail consumers, professional catering networks, and international buyers worldwide.', image: img('assets/images/market.jpg') },
  ],

  storyCards: [
    { title: 'Royal Family Dining', text: 'Bring the royal taste, delightful aroma, and unmatched quality of Golden Taj Basmati rice to your family table.', image: img('assets/images/1.jpg') },
    { title: 'Our Excellence Journey', text: 'A journey inspired by excellence, from the careful selection of the finest paddy to global distribution.', image: img('assets/images/ourstory.jpg') },
    { title: 'Purpose-Driven Values', text: 'Guided by values and driven by purpose—embracing integrity, excellence, and modern technology in everything we do.', image: img('assets/images/value.jpg') },
    { title: 'The Finest Origins', text: "The finest begins at the source, carefully selected from India's most renowned, climate-blessed Basmati growing regions.", image: img('assets/images/source.jpg') },
    { title: 'Trust Through Quality', text: 'Building trust through quality by delivering premium agricultural products with advanced processing and long-term partnerships.', image: img('assets/images/iao.jpg') },
    { title: 'Vision And Mission', text: "Driven by a vision to establish Golden Taj among the world's most trusted, sustainable, and premium rice brands.", image: img('assets/images/mission.jpg') },
    { title: 'Aged To Perfection', text: 'Time creates perfection through our expert aging process, enhancing natural aroma, fluffy texture, and superior taste.', image: img('assets/images/9.jpg') },
    { title: 'Expert Steam Rice', text: 'Perfectly aged and expertly steamed to lock in a natural aroma and ensure fluffy, non-sticky perfection every time.', image: img('assets/images/11.jpg') },
    { title: 'The Biryani Secret', text: 'Discover the secret to every memorable biryani with extra-long, naturally aromatic grains crafted for absolute culinary perfection.', image: img('assets/images/12.jpg') },
    { title: 'Our Premium Collection', text: 'Explore our elite collection of authentic Basmati varieties, masterfully grown and packed to elevate any menu.', image: img('assets/images/13.jpg') },
    { title: 'For Every Occasion', text: 'From cherished family celebrations and grand weddings to daily meals, our rice is the perfect choice for any event.', image: img('assets/images/14.jpg') },
    { title: 'The Brand Promise', text: 'Backed by our steadfast promise of premium quality, authentic taste, and rich aroma because every meal deserves to be extraordinary.', image: img('assets/images/20.jpg') },
    { title: "Management's Core Message", text: 'A reflection of our deep passion for quality, tradition, and our enduring commitment to the global families we serve.', image: img('assets/images/message.jpg') },
    { title: 'Connect With Us', text: 'Reach out to our offices, explore our official digital channels, and let us bring extraordinary flavor to your kitchen.', image: img('assets/images/22.jpg') },
  ],

  recipeGroups: [
    {
      id: 'biryani',
      title: 'Biryani Recipes',
      icon: 'fa-bowl-food',
      intro: 'Experience the rich aroma, authentic taste and premium quality of Golden Taj Basmati Rice through these world-famous biryani recipes.',
      items: [
        {
          slug: 'chicken-biryani',
          name: 'Chicken Biryani',
          image: img('assets/images/recipes/chicken-biryani.jpg'),
          text: 'Chicken Biryani is one of the most loved rice dishes around the world. Prepared with premium long-grain basmati rice, tender chicken and aromatic spices, it delivers a perfect blend of flavor, aroma and texture. The rich taste and royal presentation make it ideal for family gatherings, celebrations and special occasions.',
        },
        {
          slug: 'veg-biryani',
          name: 'Veg Biryani',
          image: img('assets/images/recipes/veg-biryani.jpg'),
          text: 'Veg Biryani is a delightful combination of premium basmati rice, fresh vegetables and traditional Indian spices. Every grain remains fluffy and separate, creating a flavorful and nutritious meal. It is a perfect choice for vegetarians who enjoy authentic biryani flavors without compromising on taste.',
        },
        {
          slug: 'hyderabadi-biryani',
          name: 'Hyderabadi Biryani',
          image: img('assets/images/recipes/hyderabadi-biryani.jpg'),
          text: 'Hyderabadi Biryani is a royal delicacy known for its authentic dum-cooking process and rich blend of spices. Layers of fragrant basmati rice and flavorful ingredients are slow-cooked to perfection, resulting in an irresistible aroma and exceptional taste. It is considered one of India\'s most iconic rice dishes.',
        },
      ],
    },
    {
      id: 'indian',
      title: 'Indian Recipes',
      icon: 'fa-utensils',
      intro: 'Discover the authentic flavors of India with traditional rice recipes prepared using premium Golden Taj Basmati Rice. From everyday comfort meals to festive favorites, these dishes bring taste and tradition together.',
      items: [
        {
          slug: 'jeera-rice',
          name: 'Jeera Rice',
          image: img('assets/images/recipes/jeera-rice.jpg'),
          text: 'Jeera Rice is a classic Indian dish prepared with fragrant basmati rice and roasted cumin seeds. Its subtle aroma and delicate flavor make it the perfect companion for dals, curries and traditional Indian meals. The long grains of Golden Taj Rice enhance both the presentation and taste of this timeless favorite.',
        },
        {
          slug: 'vegetable-pulao',
          name: 'Vegetable Pulao',
          image: img('assets/images/recipes/pulao.jpg'),
          text: 'Vegetable Pulao is a colorful and nutritious rice dish made with fresh vegetables, aromatic herbs and flavorful spices. The perfectly cooked basmati rice absorbs the rich flavors while maintaining its light and fluffy texture, making it ideal for family lunches and special occasions.',
        },
        {
          slug: 'dal-rice',
          name: 'Dal Rice',
          image: img('assets/images/recipes/dal-rice.jpg'),
          text: 'Dal Rice is one of India\'s most comforting and wholesome meals. Combining steamed basmati rice with protein-rich lentils creates a balanced and satisfying dish that is both nutritious and delicious. It is enjoyed daily in homes across the country for its simplicity and health benefits.',
        },
      ],
    },
    {
      id: 'global',
      title: 'Global Recipes',
      icon: 'fa-globe',
      intro: 'Explore international rice dishes crafted with premium Golden Taj Basmati Rice. From healthy rice bowls to Mediterranean and Asian-inspired cuisine, these recipes bring global flavors to your dining table.',
      items: [
        {
          slug: 'rice-bowl',
          name: 'Rice Bowl',
          image: img('assets/images/recipes/rice-bowl.jpg'),
          text: 'Rice Bowls are modern and nutritious meals that combine fluffy basmati rice with fresh vegetables, proteins and flavorful toppings. Popular around the world, they offer a balanced combination of taste, nutrition and convenience, making them perfect for healthy everyday dining.',
        },
        {
          slug: 'mediterranean-rice',
          name: 'Mediterranean Rice',
          image: img('assets/images/recipes/mediterranean-rice.jpg'),
          text: 'Mediterranean Rice is inspired by the vibrant flavors of Mediterranean cuisine. Prepared with premium rice, colorful vegetables, herbs and healthy ingredients, this dish is known for its refreshing taste, nutritional value and appealing presentation.',
        },
        {
          slug: 'asian-rice',
          name: 'Asian Rice Dish',
          image: img('assets/images/recipes/asian-rice.jpg'),
          text: 'Asian Rice Dishes are celebrated for their rich flavors, aromatic seasonings and colorful ingredients. Whether stir-fried or steamed, premium basmati rice provides the perfect foundation for creating authentic Asian-inspired meals with excellent texture and taste.',
        },
      ],
    },
    {
      id: 'healthy',
      title: 'Healthy Recipes',
      icon: 'fa-heart-pulse',
      intro: 'Enjoy nutritious and wholesome rice-based meals prepared with premium Golden Taj Rice. These healthy recipes combine balanced nutrition, fresh ingredients and exceptional taste to support a healthy lifestyle.',
      items: [
        {
          slug: 'brown-rice-bowl',
          name: 'Brown Rice Bowl',
          image: img('assets/images/recipes/brown-rice.jpg'),
          text: 'Brown Rice Bowl is a nutrient-rich meal packed with fiber, vitamins and essential minerals. Combined with fresh vegetables and healthy toppings, it provides long-lasting energy and supports overall wellness. It is a perfect choice for fitness enthusiasts and health-conscious individuals.',
        },
        {
          slug: 'rice-salad',
          name: 'Rice Salad',
          image: img('assets/images/recipes/rice-salad.jpg'),
          text: 'Rice Salad is a refreshing combination of cooked rice, fresh vegetables, herbs and light dressing. It offers a perfect balance of texture, flavor and nutrition while serving as a healthy option for lunch, dinner or summer meals.',
        },
        {
          slug: 'healthy-rice-meal',
          name: 'Healthy Rice Meal',
          image: img('assets/images/recipes/healthy-rice.jpg'),
          text: 'Healthy Rice Meal is designed for people who seek nutritious and balanced food without compromising on taste. Prepared with premium rice, fresh vegetables and wholesome ingredients, it delivers essential nutrients while maintaining excellent flavor and satisfaction.',
        },
      ],
    },
  ],

  occasions: [
    { name: 'Weddings', image: img('assets/images/occasion/wedding.jpg') },
    { name: 'Festivals', image: img('assets/images/occasion/festival.jpg') },
    { name: 'Celebrations', image: img('assets/images/occasion/celebration.jpg') },
    { name: 'Daily Meals', image: img('assets/images/occasion/daily-meal.jpg') },
    { name: 'Restaurants', image: img('assets/images/occasion/hospitality.jpg') },
    { name: 'Catering', image: img('assets/images/occasion/catering.jpg') },
  ],

  qualityAssurance: {
    image: img('assets/images/company/quality-assurance.jpg'),
    tag: 'Quality First',
    title: 'Committed To Delivering Premium Quality Rice',
    paragraphs: [
      'At Imperial Agro Overseas, quality is the foundation of everything we do. Every grain of rice undergoes strict inspection and testing procedures to ensure consistency, purity, aroma, and superior cooking performance.',
      'Our dedicated quality control team continuously monitors every stage of processing, packaging, and storage to meet international food safety and export standards.',
    ],
    process: [
      { icon: 'fa-search', title: 'Raw Material Inspection', text: 'Careful selection of premium quality paddy.' },
      { icon: 'fa-filter', title: 'Cleaning & Sorting', text: 'Removal of impurities through advanced systems.' },
      { icon: 'fa-ruler', title: 'Grain Analysis', text: 'Uniform grain length and consistency checks.' },
      { icon: 'fa-vial', title: 'Lab Testing', text: 'Regular testing for quality and food safety.' },
      { icon: 'fa-box-open', title: 'Packaging Inspection', text: 'Ensuring hygienic and secure packaging.' },
      { icon: 'fa-truck', title: 'Final Dispatch Check', text: 'Verification before shipment and export.' },
    ],
    parameters: [
      { icon: 'fa-shield-alt', title: 'Purity Check' },
      { icon: 'fa-droplet', title: 'Moisture Control' },
      { icon: 'fa-wind', title: 'Aroma Evaluation' },
      { icon: 'fa-ruler-combined', title: 'Length Analysis' },
      { icon: 'fa-utensils', title: 'Cooking Test' },
    ],
    commitments: [
      { icon: 'fa-award', title: 'Premium Standards' },
      { icon: 'fa-check-circle', title: 'Strict Quality Control' },
      { icon: 'fa-globe', title: 'Export Quality Products' },
      { icon: 'fa-handshake', title: 'Customer Satisfaction' },
    ],
  },

  infrastructure: {
    image: img('assets/images/company/infrastructure.jpg'),
    tag: 'Modern Facilities',
    title: 'State-of-the-Art Infrastructure',
    paragraphs: [
      'Imperial Agro Overseas is equipped with advanced infrastructure and modern rice processing facilities that ensure superior product quality, efficiency, and consistency.',
      'Our integrated processing system includes cleaning, grading, milling, sorting, packaging, and storage units designed to meet international quality standards.',
    ],
    facilities: [
      { icon: 'fa-industry', title: 'Modern Processing Unit', text: 'Advanced machinery for efficient rice processing.' },
      { icon: 'fa-filter', title: 'Color Sorting System', text: 'Ensuring uniform grain quality and appearance.' },
      { icon: 'fa-warehouse', title: 'Storage Facility', text: 'Large storage capacity under controlled conditions.' },
      { icon: 'fa-box-open', title: 'Packaging Unit', text: 'Food-grade packaging maintaining freshness.' },
      { icon: 'fa-shield-alt', title: 'Quality Lab', text: 'Rigorous testing and quality inspection process.' },
      { icon: 'fa-truck', title: 'Logistics Support', text: 'Timely dispatch and export management.' },
    ],
    highlights: [
      { icon: 'fa-cogs', title: 'Advanced Machinery' },
      { icon: 'fa-award', title: 'Quality Standards' },
      { icon: 'fa-globe', title: 'Export Ready Operations' },
      { icon: 'fa-check-circle', title: 'Hygienic Processing' },
    ],
  },

  visionMission: {
    vision: {
      icon: 'fa-eye',
      title: 'Our Vision',
      text: 'To become a globally recognized leader in the rice industry by delivering premium quality rice products that represent purity, trust, and excellence. We aspire to build long-term relationships with customers worldwide through innovation, consistency, and sustainable growth.',
    },
    mission: {
      icon: 'fa-bullseye',
      title: 'Our Mission',
      text: 'To provide superior quality Basmati Rice through advanced processing techniques, strict quality control, and customer-focused services while maintaining the highest standards of food safety, integrity, and reliability.',
    },
    values: [
      { icon: 'fa-award', title: 'Quality', text: 'Delivering the finest quality rice products.' },
      { icon: 'fa-handshake', title: 'Integrity', text: 'Building trust through ethical business practices.' },
      { icon: 'fa-users', title: 'Customer Focus', text: 'Creating value and satisfaction for our customers.' },
      { icon: 'fa-globe', title: 'Global Reach', text: 'Serving international markets with excellence.' },
    ],
  },

  companyHighlights: ['Premium Quality', 'Modern Processing', 'Global Exports', 'Customer Satisfaction'],
  whyChooseList: [
    'Premium Quality Rice',
    'Hygienic Processing',
    'Competitive Pricing',
    'Timely Delivery',
    'Export Quality Packaging',
    'International Standards',
  ],
};

export default DEFAULTS;
